import { store } from '../../store'
import { ApplicationVersion } from '../../entity'

export const saveApplicationVersion = async ( applicationVersion: ApplicationVersion ) => {

    let response

    try {

        response = await fetch( `${ process.env.REACT_APP_API_ORIGIN }/1.0.0/cms/application-versions`, {
            body: JSON.stringify( applicationVersion ),
            headers: {
                'Authorization': 'Bearer ' + store.getState().session.token,
                'Content-Type': 'application/json'
            },
            method: 'POST'
        } )

    } catch ( exception ) {

        store.dispatch( { type: 'SAVE_APPLICATION_VERSION_TIMEOUT' } )
        return

    }

    if ( response.status === 401 ) {

        store.dispatch( { type: 'SAVE_APPLICATION_VERSION_UNAUTHORIZED' } )
        return

    }

    if ( response.status !== 200 ) {

        store.dispatch( { type: 'SAVE_APPLICATION_VERSION_UNEXPECTEDRESPONSE' } )
        return

    }

    store.dispatch( { type: 'SAVE_APPLICATION_VERSION_OK' } )

}